export default __webpack_public_path__ + "static/media/prismatic-lake-blur.048e268b.jpg";